import SuccesSendReinscription from './SuccesSendReinscription';
export default SuccesSendReinscription;
